import { jsx as o, Fragment as n } from "react/jsx-runtime";
import { Select as f } from "@chakra-ui/react";
import r from "react";
import { Icon as s } from "../icon/icon.js";
import { Icons as p } from "../icon/types.js";
import { ThemeIconSizeVariable as a } from "../../theme/theme-types.js";
const h = r.forwardRef(
  ({ children: t, size: m = "md", variant: e = "outline", ...c }, i) => {
    const l = r.useCallback(() => e === "ghost" ? /* @__PURE__ */ o(n, {}) : /* @__PURE__ */ o(s, { icon: p.TreeViewCollapse, size: a.Small }), [e]);
    return /* @__PURE__ */ o(f, { ref: i, size: m, icon: l(), variant: e, ...c, children: t });
  }
);
export {
  h as Select
};
